import {graphql} from '~/graphql-react-query/';

export const ViewerQuery = graphql(`
    query ViewerQuery($options: ViewerQueryOptions) {
        viewer(options: $options) {
            id
            userOnboardingInfo {
                isAustraliaOnboarded
            }
            teams {
                id
                name
                role
                products {
                    product
                    industryIds
                    industries
                    mediaTypes
                    mediaTypeIds
                    status
                    metadata
                    country
                    compliance {
                        AU {
                            AANA_CODE_OF_ETHICS
                            AANA_FOOD_AND_BEVERAGES_ADVERTISING_CODE
                            AANA_CHILDRENS_ADVERTISING_CODE
                            AANA_ENVIRONMENTAL_CLAIMS_CODE
                            AANA_WAGERING_ADVERTISING_CODE
                            FCAI_CODE
                            TGA_CODE
                            ABAC_CODE
                        }
                    }
                }
                trialExpired
                hasTrialTeamName
                requestedNzTrial
                downloadCount
            }
            user {
                firstname
                id
                lastname
                name
                username
                createdAt
                registrationStatus
                sessionMetadata
            }
        }
    }
`);
